const manutencao_cao_de_estrutura_para_escola = {
  path: "/manutencao-de-ensino-para-escola",
  redirect: "/disciplina",
  meta: {
    breadCrumb: "Gerenciamento de Matrícula - Parâmetros por Escola",
  },
  children: [
    {
      path: "/manutencao-de-ensino-para-escola/novo",
      name: "manutencao_de_ensino_para_escola_novo",
      meta: {
        allowedPermissions: ["ensino_escola_create"],
      },
      component: () =>
        import(
          "@/views/ManutencaoDeEnsinoParaEscola/ManutencaoDeEnsinoParaEscolaCad.vue"
        ),
    },
    {
      path: "/manutencao-de-ensino-para-escola/edit/:id",
      name: "manutencao_de_ensino_para_escola_atualizar",
      meta: {
        allowedPermissions: ["ensino_escola_edit"],
      },
      component: () =>
        import(
          "@/views/ManutencaoDeEnsinoParaEscola/ManutencaoDeEnsinoParaEscolaEdit.vue"
        ),
    },
    {
      path: "/manutencao-de-ensino-para-escola",
      name: "manutencao_de_ensino_para_escola",
      meta: {
        allowedPermissions: ["ensino_escola_index"],
      },
      component: () =>
        import(
          "@/views/ManutencaoDeEnsinoParaEscola/ManutencaoDeEnsinoParaEscolaHome.vue"
        ),
    },
  ],
};

export { manutencao_cao_de_estrutura_para_escola };
